function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", {
  strokeOpacity: 0.25
}, /*#__PURE__*/React.createElement("path", {
  id: "separate-2_svg__a",
  d: "M0 0h56v74H0z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "separate-2_svg__b",
  width: 60,
  height: 78,
  x: -2,
  y: -2
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-2-2h60v78H-2z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#separate-2_svg__a"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#262C37",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.25,
  transform: "translate(422 3)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  strokeDasharray: "4,4",
  strokeWidth: 4,
  mask: "url(#separate-2_svg__b)",
  xlinkHref: "#separate-2_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 19.5h26m-26 12h26m-26 12h26m-26 12h26",
  strokeWidth: 2
}));

function SvgSeparate2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 81
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iOTAwIiBoZWlnaHQ9IjgxIiB2aWV3Qm94PSIwIDAgOTAwIDgxIj4KICAgIDxkZWZzIHN0cm9rZS1vcGFjaXR5PSIuMjUiPgogICAgICAgIDxwYXRoIGlkPSJhIiBkPSJNMCAwaDU2djc0SDB6Ii8+CiAgICAgICAgPG1hc2sgaWQ9ImIiIHdpZHRoPSI2MCIgaGVpZ2h0PSI3OCIgeD0iLTIiIHk9Ii0yIj4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTS0yLTJoNjB2NzhILTJ6Ii8+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIHN0cm9rZT0iIzI2MkMzNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utb3BhY2l0eT0iLjI1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MjIgMykiPgogICAgICAgICAgICA8dXNlICBzdHJva2UtZGFzaGFycmF5PSI0LDQiIHN0cm9rZS13aWR0aD0iNCIgbWFzaz0idXJsKCNiKSIgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICAgICAgPGcgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNSAxOS41aDI2TTE1IDMxLjVoMjZNMTUgNDMuNWgyNk0xNSA1NS41aDI2Ii8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgSeparate2 as ReactComponent };